module.exports = __webpack_public_path__ + "img/imgeditaddrbt.1240e5dc.png";